<template>
  <div class="manage_page">
    <!-- 操作 -->
    <div class="manage_operate flex-rowl">
      <div class="operate_add flex-rowc" @click="handleShowPopup('')">
        <span class="iconfont icon-jiahao1"></span> Add New
      </div>
    </div>

    <!-- 收获列表 -->
    <div
      class="manage_container"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <div class="manage_list" v-if="!loading && logisticsList.length > 0">
        <div
          class="manage_item"
          v-for="(item, index) in logisticsList"
          :key="index"
        >
          <div class="manage_operation flex-rowr">
            <i
              class="iconfont icon-xiugai"
              @click="handleShowPopup(item.id)"
            ></i>
            <i class="iconfont icon-guanbi" @click="handleDelete(item)"></i>
          </div>
          <div class="manage_main flex-rowl">
            <span class="iconfont icon-gerenxinxi"></span>
            <div class="manage_content flex-rowl">
              <div class="manage_content_block">
                <h1>{{ item.truename }}</h1>
                <p>{{ item.mobile }}</p>
                <p>
                  <span>{{ item.countrystr }}、</span
                  ><span>{{ item.province }}、</span
                  ><span>{{ item.city }}、</span><span>{{ item.area }}、</span>
                </p>
              </div>
              <div class="manage_content_block">
                <p>{{ item.addr }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no_data" v-if="!loading && logisticsList.length == 0">
        <el-empty description="暂无内容"></el-empty>
      </div>
    </div>

    <!-- 分页 start -->
    <div class="commodity_pagin flex-rowc" v-if="!loading && logisticsList.length > 0">
      <!-- jumper -->
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="15"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 收货信息弹窗 -->
    <el-dialog
      :title="formData.id ? '编辑收货信息' : '新增收货信息'"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      @close="handleCloseDialog"
    >
      <div class="el-dialog-div">
        <el-form
          :model="formData"
          label-position="top"
          ref="formData"
          :rules="ruleFormDate"
        >
          <el-form-item label="收件人" prop="truename">
            <el-input
              v-model="formData.truename"
              placeholder="请输入收件人姓名"
              maxlength="60"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="请输入手机号"
              maxlength="20"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮编">
            <el-input
              v-model="formData.zipcode"
              placeholder="请输入邮编"
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="省/直辖市" prop="province">
                <el-input
                  v-model="formData.province"
                  placeholder="请输入省/直辖市"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="城市" prop="city">
                <el-input
                  v-model="formData.city"
                  placeholder="请输入城市"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="所在区域" prop="area">
                <el-input
                  v-model="formData.area"
                  placeholder="请输入所在区域"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="详细地址" prop="addr">
            <el-input
              type="textarea"
              v-model="formData.addr"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="发货服务类型" prop="ltid">
            <el-radio v-model="formData.ltid" :label="2">{{
              ltidstr
            }}</el-radio>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleCloseDialog">取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          class="custom-button"
          @click="handleSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
import {
  getSendServiceList,
} from "../../api/api";
import {
  getLogisticsAddressList,
  addLogisticsAddress,
  editLogisticsAddress,
  getLogisticsAddressDetail,
  delLogisticsAddress,
} from "../../api/managCenter";
import { mapState } from "vuex";
export default {
  name: "receivingInfo",
  data() {
    return {
      showDialog: false,
      // 参数

      userCompanyCard: "",
      formData: {
        id: "",
        openid: "",
        country: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        zipcode: "",
        truename: "",
        mobile: "",
        ltid: 2,
      },
      ruleFormDate: {
        truename: [
          {
            required: true,
            message: "请输入收件人姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],

        province: [
          {
            required: true,
            message: "请输入省/直辖市",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "请输入城市",
            trigger: "blur",
          },
        ],
        area: [
          {
            required: true,
            message: "请输入所在区域",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: true,
            message: "请输入详细地址",
            trigger: "blur",
          },
        ],
      },
      ltidstr: "",

      loading: false,
      // 物流记录
      logisticsList: [],
      // 物流记录数量
      totalNum: 0,
      // 物流记录参数
      logisticsForm: {
        pageindex: 1,
        pagesize: 15,
        keyword: "",
        openid: "",
        countryids: "",
      },
      // 物流详情
      logisticsDetail: {},
    };
  },
  computed: {
    ...mapState(["COUNTRYLIST", "OPENID", "USERINFO"]),
  },
  mounted() {
    console.log(this.OPENID,'===this.OPENID');
    
    this.formData.openid = this.OPENID;
    this.logisticsForm.openid = this.OPENID;
    this.logisticsForm.countryids = this.USERINFO.countryExrateObj.countryid;
    this.formData.country = this.USERINFO.countryExrateObj.countryid;
    this.getLogisticsAddressList();
    this.getSendServiceList();
  },
  methods: {
    // 手机号隐藏四位
    // formatPhone(row) {
    //   const phone = row.mobile;
    //   let hiddenPhone = "";
    //   if (phone.length === 11) {
    //     hiddenPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    //   }

    //   return hiddenPhone;
    // },

    getSendServiceList() {
      let params = {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
      };
      getSendServiceList(params).then((res) => {
        res.list.forEach((item) => {
          if (item.id == 2) {
            this.formData.ltid = item.id;
            this.ltidstr = item.ltname;
          }
        });
      });
    },

    // 获取物流记录
    getLogisticsAddressList() {
      this.loading = true;
      getLogisticsAddressList(this.logisticsForm).then((res) => {
        this.logisticsList = res.list;
        this.totalNum = res.total;
        this.loading = false;
      });
    },
    // 新增物流记录
    addLogisticsAddress() {
      addLogisticsAddress(this.formData).then((res) => {
        if (res.result) {
          this.getLogisticsAddressList();
          this.showDialog = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 编辑物流记录
    editLogisticsAddress() {
      editLogisticsAddress(this.formData).then((res) => {
        if (res.result) {
          this.getLogisticsAddressList();
          this.showDialog = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取物流记录详情
    getLogisticsAddressDetail() {
      getLogisticsAddressDetail({ id: this.formData.id }).then((res) => {
        this.logisticsDetail = res;

        this.formData.truename = res.truename ? res.truename : "";
        this.formData.mobile = res.mobile ? res.mobile : "";
        this.formData.zipcode = res.zipcode ? res.zipcode : "";
        this.formData.province = res.province ? res.province : "";
        this.formData.city = res.city ? res.city : "";
        this.formData.area = res.area ? res.area : "";
        this.formData.addr = res.addr ? res.addr : "";
        this.formData.ltid = res.ltid ? res.ltid : 2;
      });
    },

    // 删除物流记录
    delLogisticsAddress(id) {
      delLogisticsAddress({ id, openid: this.OPENID }).then((res) => {
        if (res.result) {
          this.getLogisticsAddressList();
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    handleCloseDialog() {
      this.showDialog = false;
      // 清空数据
      this.formData = {
        id: "",
        openid: this.OPENID,
        country: this.USERINFO.countryExrateObj.countryid,
        province: "",
        city: "",
        area: "",
        addr: "",
        zipcode: "",
        truename: "",
        mobile: "",
      };
      this.$refs["formData"].resetFields();
    },

    // 显示弹窗
    handleShowPopup(id) {
      if (id) {
        this.formData.id = id;
        this.getLogisticsAddressDetail();
        this.showDialog = true;
      } else {
        this.showDialog = true;
      }
    },

    // 分页
    handleCurrentChange(e) {
      this.logisticsForm.pageindex = e;
      this.getLogisticsAddressList();
    },

    // 删除数据
    handleDelete(row) {
      this.delLogisticsAddress(row.id);
    },

    // 提交数据
    handleSubmit() {

      console.log(this.formData,'====this.formData');
      
      this.$refs.formData.validate((valid) => {
        if (valid) {
          if (this.formData.id) {
            this.editLogisticsAddress();
          } else {
            this.addLogisticsAddress();
          }
        }
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.manage_container {
  margin: 30px auto;
  height: 55vh;
  overflow-y: scroll;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
  }
  .manage_list {
    .manage_item {
      width: 1300px;
      // height: 160px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5);
      border-radius: 30px;
      padding: 15px 20px 25px 50px;
      box-sizing: border-box;
      margin-bottom: 10px;
      .manage_operation {
        .icon-xiugai {
          cursor: pointer;
          font-size: 28px;
        }
        .icon-guanbi {
          cursor: pointer;
          font-size: 24px;
          font-weight: bold;
          margin-left: 20px;
        }
      }
      .manage_main {
        .icon-gerenxinxi {
          font-size: 34px;
          margin-right: 34px;
        }
        .manage_content {
          align-items: flex-start;
          .manage_content_block {
            &:first-child {
              width: 420px;
              flex-shrink: 0;
            }
            color: #aaaaaa;
            h1 {
              font-size: 18px;
              font-weight: 600;
              margin-bottom: 8px;
            }
            p {
              font-size: 16px;
              margin-bottom: 8px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
.el-dialog-div {
  height: 54vh;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .el-select {
    width: 100%;
  }
}
</style>